import { render, staticRenderFns } from "./TheSourceMetric.vue?vue&type=template&id=13e4a112&scoped=true&"
import script from "./TheSourceMetric.vue?vue&type=script&lang=js&"
export * from "./TheSourceMetric.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceMetric.vue?vue&type=style&index=0&id=13e4a112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4a112",
  null
  
)

export default component.exports